module.exports = __webpack_public_path__ + "static/media/trait-icons-competitiveness.bcfe3f05.svg";